import React from "react";
import {Link} from 'react-router-dom';

function Footer(){
    return (
        <footer style={{position:'relative',background: '#000000'}}>
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="de-flex">
                                <div className="de-flex-col">
                                    <Link to="/">
                                        <span className="copy">&copy; Billionaire Tigers</span>
                                    </Link>
                                </div>
                                <div className="de-flex-col">
                                    <Link to="/">
                                        <span className="copy">Terms & Conditions</span>
                                    </Link>
                                </div>
                                <div className="de-flex-col">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/Billionaire-Tigers-109514221575309" className="social_anch" rel="noreferrer" target="_blank"><i className="fa fa-facebook fa-lg"></i></a>
                                        <Link to="/" className="social_anch"><i className="fa fa-twitter fa-lg"></i></Link>
                                        <a href="https://www.instagram.com/billionairetigers/" rel="noreferrer" target="_blank" className="social_anch"><i className="fa fa-instagram fa-lg"></i></a>
                                        <a href="https://discord.gg/J2e3DFb6uH" rel="noreferrer" target="_blank" className="dribbl_anch"><img alt="discord" height="12px" src={'images/discord.png'}/></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
export default Footer;
